/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Member } from './Member';
import {
    MemberFromJSON,
    MemberFromJSONTyped,
    MemberToJSON,
} from './Member';

/**
 * 
 * @export
 * @interface ListLinkedMembers200Response
 */
export interface ListLinkedMembers200Response {
    /**
     * 
     * @type {Array<Member>}
     * @memberof ListLinkedMembers200Response
     */
    data: Array<Member>;
}

/**
 * Check if a given object implements the ListLinkedMembers200Response interface.
 */
export function instanceOfListLinkedMembers200Response(value: object): value is ListLinkedMembers200Response {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ListLinkedMembers200ResponseFromJSON(json: any): ListLinkedMembers200Response {
    return ListLinkedMembers200ResponseFromJSONTyped(json, false);
}

export function ListLinkedMembers200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListLinkedMembers200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(MemberFromJSON)),
    };
}

export function ListLinkedMembers200ResponseToJSON(value?: ListLinkedMembers200Response | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ((value['data'] as Array<any>).map(MemberToJSON)),
    };
}

